import { render } from "./testing-page-break-ok.vue?vue&type=template&id=540ac6ea&scoped=true"
import script from "./testing-page-break-ok.vue?vue&type=script&lang=js"
export * from "./testing-page-break-ok.vue?vue&type=script&lang=js"

import "./testing-page-break-ok.vue?vue&type=style&index=0&id=540ac6ea&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540ac6ea"]])

export default __exports__